import axios from 'axios';

async function sendSupportMessage(message) {
  const url = `Application/Support/Message`;
  const request = {
    method: 'POST',
    url: url,
    data: message,
  };

  const res = await axios(request);
  return res.data;
}




const ApplicationService = {
  API: {
    sendSupportMessage,
  },
};

export default ApplicationService;